export enum MobileNavigationBarItemMobilePosition {
  QUICK_ACCESS,
  MENU
}
